import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";
import { initializeCapacitor } from "./lib/capacitor";

// ======================================================
// Sentry init (deve ser ANTES de qualquer outra coisa)
// ======================================================
Sentry.init({
  dsn: 'https://700e87d069a1e329e7342402865cbf24@o4510909125689344.ingest.us.sentry.io/4510909129949184',

  // IMPORTANTE: isso ajuda MUITO em filtros
  environment: import.meta.env.MODE,

  // IMPORTANTE: release precisa bater com o upload de sourcemaps
  // Defina VITE_APP_VERSION no build (ex: commit hash)
  release: import.meta.env.VITE_APP_VERSION ?? undefined,

  integrations: [
    // Captura console.error
    Sentry.captureConsoleIntegration({
      levels: ['error'],
    }),

    // Tracing normal (funciona automaticamente com React Router DOM)
    Sentry.browserTracingIntegration(),

    // Replay
    Sentry.replayIntegration(),
  ],

  sendDefaultPii: false, // evita dor de cabeça com LGPD

  // Performance (ajuste como quiser)
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

  // Replay (ajuste como quiser)
  replaysSessionSampleRate: import.meta.env.PROD ? 0.05 : 1.0,
  replaysOnErrorSampleRate: 1.0,
})

// ======================================================
// Listeners globais (opcional, mas útil)
// ======================================================
window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event.reason)
})

window.addEventListener('error', (event) => {
  // Só captura se tiver stack
  if (event.error) Sentry.captureException(event.error)
})

// Desabilita a restauração automática de scroll do navegador
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Inicializa o Capacitor para plataformas nativas
initializeCapacitor();

createRoot(document.getElementById("root")!).render(<App />);
